export const WHATSAPP_NUMBER = "918452981187";
export const WHATSAPP_DISPLAY = "+91 84529 81187";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MESSAGE =
  "Hello JK Furniture, I am interested in this product. Please share more details.";

export const productWaMessage = (product) =>
  `Hello JK Furniture, I am interested in "${product.name}" (${product.price}). Please share more details.`;

export const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=900&q=80";

export const productImageSrc = (image) => {
  if (!image) return FALLBACK_IMG;
  if (image.startsWith("http")) return image;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${image}`;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const filterShowcase = (category) => {
  window.dispatchEvent(new CustomEvent("jk:filter", { detail: category }));
  scrollToId("showcase");
};

export const CATEGORIES = [
  {
    id: "wardrobes",
    name: "Wardrobes & Cupboards",
    tagline: "Floor-to-ceiling storage",
    desc: "Sliding & hinged wardrobes crafted with marine-ply structure and genuine walnut or oak veneers.",
    image: "https://images.unsplash.com/photo-1784651858840-0f077fad4e1e?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "beds",
    name: "Beds",
    tagline: "Grounded platforms & headboards",
    desc: "Solid teak platform beds with integrated lighting, hydraulic storage and acoustic panelling.",
    image: "https://images.unsplash.com/photo-1757344454333-cc666252e596?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "bedroom",
    name: "Bedroom Furniture",
    tagline: "Complete bedroom suites",
    desc: "Coordinated bedside tables, chests of drawers and headboards built as one seamless suite.",
    image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "tv-units",
    name: "TV Units",
    tagline: "Fluted & slatted woodwork",
    desc: "Floating media consoles with hidden wire conduits, cane mesh fronts and brass trims.",
    image: "https://images.unsplash.com/photo-1680503397107-475907e4f3e3?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "tables",
    name: "Tables",
    tagline: "Live-edge slabs & joinery",
    desc: "Dining and coffee tables in single-slab acacia with dovetail joinery and matte natural sealants.",
    image: "https://images.unsplash.com/photo-1533090481720-856c6e3c1fdc?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "dressing-tables",
    name: "Dressing Tables",
    tagline: "Illuminated vanities",
    desc: "Slim timber vanities with lined jewellery trays, dimmable mirrors and matching stools.",
    image: "https://images.pexels.com/photos/16476339/pexels-photo-16476339/free-photo-of-antique-dressing-table.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "sofa-beds",
    name: "Sofa Beds",
    tagline: "Smooth pull-out comfort",
    desc: "High-resilience foam on kiln-dried hardwood frames, converting effortlessly from sofa to bed.",
    image: "https://images.unsplash.com/photo-1758957701419-2c6e266f7988?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "custom-furniture",
    name: "Custom Furniture",
    tagline: "Built to your measurements",
    desc: "Pooja units, walk-in closets, study desks and full millwork handcrafted to the millimetre.",
    image: "https://images.pexels.com/photos/8135264/pexels-photo-8135264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-2 lg:col-span-4",
  },
];

export const FALLBACK_PRODUCTS = [
  {
    id: "p-1",
    name: "The Bandra Teak King Bed",
    category: "Beds",
    price: "₹48,500",
    description: "Minimalist platform bed in kiln-dried solid teak with hydraulic under-storage and cushioned linen headboard.",
    details: "Solid Teak • 78″L x 72″W x 42″H • Hydraulic Storage",
    image: "https://images.unsplash.com/photo-1757344454333-cc666252e596?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Bestseller",
  },
  {
    id: "p-2",
    name: "The Altamount Fluted Wardrobe",
    category: "Wardrobes & Cupboards",
    price: "₹82,000",
    description: "Four-door modular wardrobe with soft-close hinges, fluted solid wood handles and warm sensor lighting.",
    details: "Walnut Veneer + Marine Ply • 84″H x 72″W x 24″D",
    image: "https://images.unsplash.com/photo-1784651858840-0f077fad4e1e?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Architect Favorite",
  },
  {
    id: "p-3",
    name: "The Worli Live Edge Dining Table",
    category: "Tables",
    price: "₹56,000",
    description: "One-of-a-kind live-edge slab with butterfly joints and a matte scratch-resistant finish. Seats six.",
    details: "Single Slab Solid Wood • 78″L x 36″W x 30″H",
    image: "https://images.unsplash.com/photo-1533090481720-856c6e3c1fdc?auto=format&fit=crop&w=1200&q=80",
    tag: "Handcrafted",
  },
  {
    id: "p-4",
    name: "The Juhu Floating TV Console",
    category: "TV Units",
    price: "₹32,000",
    description: "Wall-mounted slatted media unit that hides every cable, with remote pass-through acoustic slats.",
    details: "Kiln-Dried Teak • 72″L x 16″D x 14″H • Concealed Wiring",
    image: "https://images.unsplash.com/photo-1680503397107-475907e4f3e3?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Smart Storage",
  },
  {
    id: "p-5",
    name: "The Malabar Timber Sofa Bed",
    category: "Sofa Beds",
    price: "₹44,000",
    description: "Effortless click-clack mechanism with high-density foam and stain-resistant linen upholstery. Opens to a queen bed.",
    details: "Hardwood Frame • 82″L x 36″D • Opens to 60″ Queen",
    image: "https://images.unsplash.com/photo-1758957701419-2c6e266f7988?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Compact Living",
  },
  {
    id: "p-6",
    name: "The Colaba Arch Dressing Table",
    category: "Dressing Tables",
    price: "₹38,000",
    description: "Floor-length arch mirror with warm dimmable backlight, four concealed drawers and a fluted storage stool.",
    details: "Natural Teak & Brass • 48″W x 18″D x 72″H",
    image: "https://images.pexels.com/photos/16476339/pexels-photo-16476339/free-photo-of-antique-dressing-table.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tag: "New Season",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&q=85";

export const ABOUT_IMAGE =
  "https://images.pexels.com/photos/7148849/pexels-photo-7148849.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const CUSTOM_IMAGE =
  "https://images.pexels.com/photos/8135264/pexels-photo-8135264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const REVEAL = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.09, ease: [0.215, 0.61, 0.355, 1] },
  }),
};
